import { render, staticRenderFns } from "./ed-class-schedule-calendar.component.vue?vue&type=template&id=fbedfd68&scoped=true&"
import script from "./ed-class-schedule-calendar.component.ts?vue&type=script&lang=ts&"
export * from "./ed-class-schedule-calendar.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-class-schedule-calendar.component.scss?vue&type=style&index=0&id=fbedfd68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbedfd68",
  null
  
)

export default component.exports